import { h, Component } from 'preact';
import cx from 'classnames';
import { Subject } from 'rxjs';
import { Listing } from '../../../../../types';
import hopplerLinkState from '../../../../utils/forms/hoppler-linkstate';
import { DivCatUtils } from '../../../../utils/div-cat-utils';
import * as Validators from '../../../../utils/forms/validators';
import { Form } from '../../../../utils/forms/form';
import { ListingEditorErrorMessage } from './error-message.component';

interface ListingEditorAmenitiesSectionProps {
  listing?: Listing;
  requiresBuilding?: boolean;
  form?: Form;
  formSubject?: Subject<Form>;
  isPending?: number;
}

interface ListingEditorAmenitiesSectionState {}

export class ListingEditorAmenitiesSection extends Component<ListingEditorAmenitiesSectionProps, ListingEditorAmenitiesSectionState> {
  dcUtils = new DivCatUtils();

  render() {
    const {
      form,
      formSubject,
      listing,
      isPending 
    } = this.props;

    let type: string = form.fields['type'].value.toLowerCase();
    const amenitiesToUse = this.dcUtils.defineAmenities(type);
        
    return (
      <div className="mt-4">
        <label className="hi-input-group__label">Amenities</label>
        <div className="hi-dash-listings__amenities-options">
          {
            amenitiesToUse.map(member => 
              <div>
                <label>
                  <input 
                    disabled={ isPending == 1 || !listing.canEdit }
                    type="checkbox" 
                    name={member.field}
                    checked={form.fields[member.field].value == 1}
                    value={1}
                    onChange={ hopplerLinkState(formSubject, form, member.field)}/>
                  <span className="ml-2">
                    { member.label }
                  </span>
                </label>
              </div>
            )
          }
        </div>
        {
          form.fields['__hasParking'].value ?
            <div className="row mt-3">
              <div className="col">
                <div className="hi-input-group">
                  <label className="hi-input-group__label">Number of Parking Spaces*</label>
                  <input 
                    className={ cx('form-control hi-text-input',
                      {
                        'invalid': Validators.cxValidateField(form.fields['parkingSpaces'])
                      })
                    } 
                    disabled={ isPending == 1 || !listing.canEdit }
                    value={form.fields['parkingSpaces'].value} 
                    placeholder="Parking Spaces" 
                    type="number"
                    onInput={ hopplerLinkState(formSubject, form, 'parkingSpaces') }/>
                </div>

                <ListingEditorErrorMessage 
                  form={ form }
                  fieldName="parkingSpaces"
                  message="Please add a parking count"
                />

              </div>
            </div> : null
        }
      </div>
    )
  }
}